import script from "./PGComponentActionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PGComponentActionButton.vue?vue&type=script&setup=true&lang=js"

import "./PGComponentActionButton.vue?vue&type=style&index=0&id=40547d2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40547d2a"]])

export default __exports__